import { Method } from '../components/steps/StepCertificationMethod';
import useStepperState from './useStepperState';

export default function useBookingUrl(
  state: ReturnType<typeof useStepperState>
):
  | { isVisible: false; isEnabled: false }
  | { isVisible: true; isEnabled: false }
  | { isVisible: true; isEnabled: true; url: string } {
  const { activeStep, method, certification, country, center, language } = state;

  const isVisible =
    (method === Method.EXAM_ONLY && activeStep > 2) ||
    (method === Method.SELFSTUDY_EXAM && activeStep > 4);
  if (!isVisible) {
    return { isVisible, isEnabled: false };
  }

  const isEnabled = !!(
    method &&
    certification &&
    country &&
    language &&
    center &&
    ((method === Method.EXAM_ONLY && !certification?.trainingNeeded && activeStep === 5) ||
      (method === Method.EXAM_ONLY && certification?.trainingNeeded && activeStep === 6) ||
      (method === Method.SELFSTUDY_EXAM && activeStep === 7))
  );
  if (!isEnabled) {
    return { isVisible, isEnabled };
  }

  const searchParams = new URLSearchParams();
  searchParams.set('ProductGroupID', certification.productGroupId);
  searchParams.set('ExamRoomPlanning', String(1));
  searchParams.set('Framed', String(1));
  searchParams.set('NewSession', String(1));
  searchParams.set('screen', 'frameset');
  searchParams.set('ExamModuleID', certification.exillenceId);
  searchParams.set('CountryID', country.value);
  searchParams.set('ExamserviceID', center.value);
  searchParams.set('LanguageID', language.value);
  const url = `https://mylogin.exin.nl/polarserver.asp?` + searchParams.toString();

  return { isVisible, isEnabled, url };
}
